import React from 'react';
import { CtaButton } from './ui/CtaButton';
export function FinalCta() {
  return <section className="w-full bg-cream" data-id="element-53" data-mp="vffvuqzdw8t1">
      <div className="mx-auto max-w-content px-6 py-20 text-center" data-id="element-54" data-mp="vghfhjugu3md">
        <h2 className="mx-auto max-w-md font-display text-[26px] font-bold leading-[1.2] text-ink sm:text-[30px]" data-id="element-55" data-mp="19fgxi8nh3k9k">
          Gotowy, by odmienić swoje{' '}
          <em className="font-display italic text-coral" data-id="element-56" data-mp="15fgiomwgp71z">lekcje plastyki?</em>
        </h2>

        <p className="mx-auto mt-4 max-w-md text-[12px] leading-relaxed text-muted" data-id="element-57" data-mp="1jbadk20ehvw3">
          Dołącz do nauczycieli, którzy zamiast szukać inspiracji po nocach po
          prostu otwierają plik i prowadzą lekcję.
        </p>

        <div className="mt-8" data-id="element-58" data-mp="1o3vahcelsp3u">
          <CtaButton data-id="element-59" data-mp="1o4wjlbc271ix" />
        </div>

        <p className="mt-4 text-[9px] uppercase tracking-[0.14em] text-muted/80" data-id="element-60" data-mp="1o4n0m7pflumq">
          Natychmiastowy dostęp · 14 dni gwarancji · Bez subskrypcji
        </p>
      </div>
    </section>;
}